import React, { useState } from 'react';
export function BlogFilters() {
  const [activeCategory, setActiveCategory] = useState('All');
  const categories = ['All', 'Salary Guides', 'All About Locums', 'Facility Resources', 'Practitioners', 'Provider Resources'];
  return <div className="bg-white/80 backdrop-blur-md border-t border-b border-gray-100 py-6" data-id="element-67">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-68">
        <div className="flex items-center gap-1 overflow-x-auto no-scrollbar" data-id="element-69">
          {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`
                whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200
                ${activeCategory === category ? 'bg-[#374586] text-white shadow-sm' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'}
              `} style={{
          fontFamily: "'Poppins', sans-serif"
        }} data-id="element-70">
              {category}
            </button>)}
        </div>
      </div>
    </div>;
}